export interface Ticket_Interface {
  id: number,
  code: String,
  title: String,
  cateTitle: String,
  persianData: String,
  closed: boolean,
  selected: boolean,
  isNew: boolean,
  statusText: string;
  statusType: string;
}

export function Empty_Ticket_Interface(): Ticket_Interface {
  return {
    id: 0,
    code: '',
    title: '',
    cateTitle: '',
    persianData: '',
    closed: false,
    selected: false,
    isNew: false,
    statusText: '',
    statusType: '',
  }
}
